import "@xyflow/react/dist/style.css";
import {
  Background,
  BackgroundVariant,
  Controls,
  ReactFlow,
  type ReactFlowProps,
} from "@xyflow/react";

/** Shared inspection canvas. Refreshing data does not reset the viewport. */
export function ReadOnlyFlow({ children, ...props }: ReactFlowProps) {
  return (
    <ReactFlow
      {...props}
      nodesDraggable={false}
      nodesConnectable={false}
      edgesReconnectable={false}
      deleteKeyCode={null}
      edgesFocusable={false}
      minZoom={0.2}
      maxZoom={1.5}
      proOptions={{ hideAttribution: false }}
    >
      <Background variant={BackgroundVariant.Dots} gap={20} size={1} />
      <Controls position="top-left" showInteractive={false} />
      {children}
    </ReactFlow>
  );
}
